// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"styles_socialIcons__jzStb","hoverClass":"styles_hoverClass__GylXU","title":"styles_title__g2U2M"};